import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Box, Container, Grid, Typography, Divider } from "@mui/material";
import TotalApplications from "../../../components/Trainer_dashboard/TotalApplications";
import ActiveApplications from "../../../components/Trainer_dashboard/ActiveApplications";
// import InactiveApplications from "../../../components/Trainer_dashboard/InactiveApplications";
import PreconfigTotalApp from "../../../components/Trainer_dashboard/PreconfigTotalApp";
// import PreconfigStopped from "../../../components/Trainer_dashboard/PreconfigStopped";
import Preconfigactive from "../../../components/Trainer_dashboard/Preconfigactive";
import CustomconfigTotalApp from "../../../components/Trainer_dashboard/CustomconfigTotalApp";
// import CustomconfigStopped from "../../../components/Trainer_dashboard/CustomconfigStopped";
import Customconfigactive from "../../../components/Trainer_dashboard/Customconfigactive";
import HvmTotalApp from "../../../components/Trainer_dashboard/HvmTotalApp";
// import HvmStopped from "../../../components/Trainer_dashboard/HvmStopped";
import Hvmactive from "../../../components/Trainer_dashboard/Hvmactive";
import SvmTotalApp from "../../../components/Trainer_dashboard/SvmTotalApp";
// import SvmStopped from "../../../components/Trainer_dashboard/SvmStopped";
import Svmactive from "../../../components/Trainer_dashboard/Svmactive";
import CloudTotalApp from "../../../components/Trainer_dashboard/CloudTotalApp";
import Cloudactive from "../../../components/Trainer_dashboard/Cloudactive";
import WiseTotalApp from "../../../components/Trainer_dashboard/WiseTotalApp";
// import WiseStopped from "../../../components/Trainer_dashboard/WiseStopped";
import Wiseactive from "../../../components/Trainer_dashboard/Wiseactive";
import ManualTotalApp from "../../../components/Trainer_dashboard/ManualTotalApp";
// import ManualStopped from "../../../components/Trainer_dashboard/ManualStopped";
import Manualactive from "../../../components/Trainer_dashboard/Manualactive";
import SasTotalApp from "../../../components/Trainer_dashboard/SasTotalApp";
// import SasStopped from "../../../components/Trainer_dashboard/SasStopped";
import Sasactive from "../../../components/Trainer_dashboard/Sasactive";

const Dashboard = () => {
  // const [applicationchart, setApplicationchart] = useState([]);
  const [labscard, setLabscard] = useState([]);
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [labsRes] = await Promise.all([
          // fetch(`${process.env.REACT_APP_API_URL}/api/labchart/`, {
          //   headers: {
          //     Authorization: "Bearer " + localStorage.getItem("token"),
          //   },
          // }),
          fetch(`${process.env.REACT_APP_API_URL}/api/traineroverview/`, {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }),
        ]);

        // const chartData = await chartRes.json();
        const labsData = await labsRes.json();

        // setApplicationchart(chartData);
        setLabscard(labsData);
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <title>LabAsService</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        
        <Container maxWidth={false}>
          <Typography variant="h6" gutterBottom component="div">
            Overview:
          </Typography>
          <Grid container spacing={2}>
            <Grid
              item
              lg={6}
              sm={6}
              xl={6}
              xs={12}
              style={{
                marginRight: "auto",
                marginLeft: "auto",
                display: "block",
              }}
            >
              <TotalApplications value={labscard.total} />
            </Grid>
            <Grid
              item
              lg={6}
              sm={6}
              xl={6}
              xs={12}
              style={{
                marginRight: "auto",
                marginLeft: "auto",
                display: "block",
              }}
            >
              <ActiveApplications value={labscard.active} />
            </Grid>
            {/*<Grid
              item
              lg={4}
              sm={6}
              xl={4}
              xs={12}
              style={{
                marginRight: "auto",
                marginLeft: "auto",
                display: "block",
              }}
            >
              <InactiveApplications value={labscard.inactive} sx={{ height: "100%" }} />
            </Grid>
            <Grid
              item
              lg={4}
              sm={6}
              xl={4}
              xs={12}
              style={{
                marginRight: "auto",
                marginLeft: "auto",
                display: "block",
              }}
            >
               <ResourceUsage value={labscard.balance} sx={{ height: "100%" }} />
            </Grid> */}
          </Grid>
          <hr />
          <br />
          <Grid container spacing={3}>
            <Grid item xl={6} xs={6}>
              <Divider>
                <Typography
                  style={{ textAlign: "-webkit-center" }}
                  variant="h6"
                  gutterBottom
                  component="div"
                >
                  PRE-CONFIGURED
                </Typography>
              </Divider>
              <Divider />
              <Grid container spacing={0}>
                <Grid
                  item
                  lg={6}
                  sm={6}
                  xl={6}
                  xs={12}
                  style={{
                    marginRight: "auto",
                    marginLeft: "auto",
                    display: "block",
                  }}
                >
                  <PreconfigTotalApp value={labscard.pretotal} />
                </Grid>
                <Grid
                  item
                  lg={6}
                  sm={6}
                  xl={6}
                  xs={12}
                  style={{
                    marginRight: "auto",
                    marginLeft: "auto",
                    display: "block",
                  }}
                >
                  <Preconfigactive value={labscard.preactive} />
                </Grid>
                {/*<Grid
                  item
                  lg={3}
                  sm={6}
                  xl={3}
                  xs={12}
                  style={{
                    marginRight: "auto",
                    marginLeft: "auto",
                    display: "block",
                  }}
                >
                  <PreconfigStopped value={labscard.prestopped} sx={{ height: "100%" }} />
                </Grid>
                <Grid
                  item
                  lg={4}
                  sm={6}
                  xl={4}
                  xs={12}
                  style={{
                    marginRight: "auto",
                    marginLeft: "auto",
                    display: "block",
                  }}
                >
                   <PreconfigCordoned value={labscard.precordoned} sx={{ height: "100%" }} /> 
                </Grid>*/}
              </Grid>
            </Grid>

            <Grid item xl={6} xs={6}>
              <Divider>
                <Typography
                  style={{ textAlign: "-webkit-center" }}
                  variant="h6"
                  gutterBottom
                  component="div"
                >
                  CUSTOM
                </Typography>
              </Divider>
              <Divider />
              <Grid container spacing={0}>
                <Grid
                  item
                  lg={6}
                  sm={6}
                  xl={6}
                  xs={12}
                  style={{
                    marginRight: "auto",
                    marginLeft: "auto",
                    display: "block",
                  }}
                >
                  <CustomconfigTotalApp value={labscard.customtotal} />
                </Grid>
                <Grid
                  item
                  lg={6}
                  sm={6}
                  xl={6}
                  xs={12}
                  style={{
                    marginRight: "auto",
                    marginLeft: "auto",
                    display: "block",
                  }}
                >
                  <Customconfigactive value={labscard.customactive} />
                </Grid>
                {/*<Grid
                  item
                  lg={3}
                  sm={6}
                  xl={3}
                  xs={12}
                  style={{
                    marginRight: "auto",
                    marginLeft: "auto",
                    display: "block",
                  }}
                >
                  <CustomconfigStopped value={labscard.customstopped} sx={{ height: "100%" }} />
                </Grid>
                 <Grid
                  item
                  lg={3}
                  sm={6}
                  xl={4}
                  xs={12}
                  style={{
                    marginRight: "auto",
                    marginLeft: "auto",
                    display: "block",
                  }}
                >
                  <CustomconfigCordoned value={labscard.customcordoned} sx={{ height: "100%" }} />
                </Grid> */}
              </Grid>
            </Grid>
          </Grid>
          <hr />
          <br />
          <Grid container spacing={3}>
            <Grid item xl={6} xs={6}>
              <Divider>
                <Typography
                  style={{ textAlign: "-webkit-center" }}
                  variant="h6"
                  gutterBottom
                  component="div"
                >
                  HYPERVISED
                </Typography>
              </Divider>
              <Divider />
              <Grid container spacing={0}>
                <Grid
                  item
                  lg={6}
                  sm={6}
                  xl={6}
                  xs={12}
                  style={{
                    marginRight: "auto",
                    marginLeft: "auto",
                    display: "block",
                  }}
                >
                  {/* <HvmTotalApp /> */}
                  <HvmTotalApp value={labscard.hvmcustotal} />
                </Grid>
                <Grid
                  item
                  lg={6}
                  sm={6}
                  xl={6}
                  xs={12}
                  style={{
                    marginRight: "auto",
                    marginLeft: "auto",
                    display: "block",
                  }}
                >
                  {/* <Hvmactive /> */}
                  <Hvmactive value={labscard.hvmcusactive} />
                </Grid>
                {/*<Grid
                  item
                  lg={4}
                  sm={6}
                  xl={4}
                  xs={12}
                  style={{
                    marginRight: "auto",
                    marginLeft: "auto",
                    display: "block",
                  }}
                >
                  <HvmStopped value={labscard.hvmcussttoped} sx={{ height: "100%" }} />
                </Grid>
                 <Grid
                  item
                  lg={4}
                  sm={6}
                  xl={4}
                  xs={12}
                  style={{
                    marginRight: "auto",
                    marginLeft: "auto",
                    display: "block",
                  }}
                >
                  <HvmCordoned value={labscard.hvmcuscordoned} sx={{ height: "100%" }} />
                </Grid> */}
              </Grid>
            </Grid>

            <Grid item xl={6} xs={6}>
              <Divider>
                <Typography
                  style={{ textAlign: "-webkit-center" }}
                  variant="h6"
                  gutterBottom
                  component="div"
                >
                  SHARED
                </Typography>
              </Divider>
              <Divider />
              <Grid container spacing={0}>
                <Grid
                  item
                  lg={6}
                  sm={6}
                  xl={6}
                  xs={12}
                  style={{
                    marginRight: "auto",
                    marginLeft: "auto",
                    display: "block",
                  }}
                >
                  <SvmTotalApp value={labscard.svmtotal}
                  // active={labscard.active}
                  />
                </Grid>
                <Grid
                  item
                  lg={6}
                  sm={6}
                  xl={6}
                  xs={12}
                  style={{
                    marginRight: "auto",
                    marginLeft: "auto",
                    display: "block",
                  }}
                >
                  <Svmactive value={labscard.svmactive} />
                </Grid>
                {/*<Grid
                  item
                  lg={4}
                  sm={6}
                  xl={4}
                  xs={12}
                  style={{
                    marginRight: "auto",
                    marginLeft: "auto",
                    display: "block",
                  }}
                >
                  <SvmStopped value={labscard.svmstopped} sx={{ height: "100%" }} />
                </Grid>
                 <Grid
                  item
                  lg={4}
                  sm={6}
                  xl={4}
                  xs={12}
                  style={{
                    marginRight: "auto",
                    marginLeft: "auto",
                    display: "block",
                  }}
                >
                  <SvmCordoned value={labscard.svmcordoned}sx={{ height: "100%" }} />
                </Grid> */}
              </Grid>
            </Grid>
          </Grid>
          <hr />
          <br />
          <Grid container spacing={3}>
            <Grid item xl={6} xs={6}>
                <Divider>
                  <Typography
                    style={{ textAlign: "-webkit-center" }}
                    variant="h6"
                    gutterBottom
                    component="div"
                  >
                    WISE
                  </Typography>
                </Divider>
                <Divider />
                <Grid container spacing={0}>
                  <Grid
                    item
                    lg={6}
                    sm={6}
                    xl={6}
                    xs={12}
                    style={{
                      marginRight: "auto",
                      marginLeft: "auto",
                      display: "block",
                    }}
                  >
                    <WiseTotalApp value={labscard.wisetotal} />
                  </Grid>
                  <Grid
                    item
                    lg={6}
                    sm={6}
                    xl={6}
                    xs={12}
                    style={{
                      marginRight: "auto",
                      marginLeft: "auto",
                      display: "block",
                    }}
                  >
                    <Wiseactive value={labscard.wiseactive} />
                  </Grid>
                  {/* <Grid
                    item
                    lg={4}
                    sm={6}
                    xl={4}
                    xs={12}
                    style={{
                      marginRight: "auto",
                      marginLeft: "auto",
                      display: "block",
                    }}
                  >
                    <WiseStopped value={labscard.wisestopped} sx={{ height: "100%" }} />
                  </Grid>
                  <Grid
                    item
                    lg={4}
                    sm={6}
                    xl={4}
                    xs={12}
                    style={{
                      marginRight: "auto",
                      marginLeft: "auto",
                      display: "block",
                    }}
                  >
                    <WiseCordoned value={labscard.wisecordoned} sx={{ height: "100%" }} />
                  </Grid> */}
                </Grid>     
            </Grid>       
            
            <Grid item xl={6} xs={6}>
              <Divider>
                <Typography
                  style={{ textAlign: "-webkit-center" }}
                  variant="h6"
                  gutterBottom
                  component="div"
                >
                  CLOUD
                </Typography>
              </Divider>
              <Divider />
              <Grid container spacing={0}>
                <Grid
                  item
                  lg={6}
                  sm={6}
                  xl={6}
                  xs={12}
                  style={{
                    marginRight: "auto",
                    marginLeft: "auto",
                    display: "block",
                  }}
                >
                  <CloudTotalApp value={labscard.cloudtotal}
                  // active={labscard.active}
                  />
                </Grid>
                <Grid
                  item
                  lg={6}
                  sm={6}
                  xl={6}
                  xs={12}
                  style={{
                    marginRight: "auto",
                    marginLeft: "auto",
                    display: "block",
                  }}
                >
                  <Cloudactive value={labscard.cloudactive} sx={{ height: "100%" }} />
                </Grid>
              </Grid>
              </Grid>
            
            <Grid item xl={3} xs={3}></Grid>
          </Grid>

          <hr />
          <br />
          <Grid container spacing={3}>
            <Grid item xl={6} xs={6}>
                <Divider>
                  <Typography
                    style={{ textAlign: "-webkit-center" }}
                    variant="h6"
                    gutterBottom
                    component="div"
                  >
                    MANUAL
                  </Typography>
                </Divider>
                <Divider />
                <Grid container spacing={0}>
                  <Grid
                    item
                    lg={6}
                    sm={6}
                    xl={6}
                    xs={12}
                    style={{
                      marginRight: "auto",
                      marginLeft: "auto",
                      display: "block",
                    }}
                  >
                    <ManualTotalApp value={labscard.manualtotal} />
                  </Grid>
                  <Grid
                    item
                    lg={6}
                    sm={6}
                    xl={6}
                    xs={12}
                    style={{
                      marginRight: "auto",
                      marginLeft: "auto",
                      display: "block",
                    }}
                  >
                    <Manualactive value={labscard.manualactive} />
                  </Grid>
                  {/* <Grid
                    item
                    lg={4}
                    sm={6}
                    xl={4}
                    xs={12}
                    style={{
                      marginRight: "auto",
                      marginLeft: "auto",
                      display: "block",
                    }}
                  >
                    <ManualStopped value={labscard.manualstopped} sx={{ height: "100%" }} />
                  </Grid> */}
                </Grid>     
            </Grid>
            
            <Grid item xl={6} xs={6}>
                <Divider>
                  <Typography
                    style={{ textAlign: "-webkit-center" }}
                    variant="h6"
                    gutterBottom
                    component="div"
                  >
                    SAAS
                  </Typography>
                </Divider>
                <Divider />
                <Grid container spacing={0}>
                  <Grid
                    item
                    lg={6}
                    sm={6}
                    xl={6}
                    xs={12}
                    style={{
                      marginRight: "auto",
                      marginLeft: "auto",
                      display: "block",
                    }}
                  >
                    <SasTotalApp value={labscard.sastotal} />
                  </Grid>
                  <Grid
                    item
                    lg={6}
                    sm={6}
                    xl={6}
                    xs={12}
                    style={{
                      marginRight: "auto",
                      marginLeft: "auto",
                      display: "block",
                    }}
                  >
                    <Sasactive value={labscard.sasactive} />
                  </Grid>
                  {/* <Grid
                    item
                    lg={3}
                    sm={6}
                    xl={4}
                    xs={12}
                    style={{
                      marginRight: "auto",
                      marginLeft: "auto",
                      display: "block",
                    }}
                  >
                    <SasStopped value={labscard.sasstopped} sx={{ height: "100%" }} />
                  </Grid> */}
                </Grid>     
            </Grid>
            
            {/* <Grid item xl={3} xs={3}></Grid> */}
          </Grid>

          {/* <Grid container spacing={1}>
            <Grid
              item
              lg={12}
              md={12}
              xl={12}
              xs={12}
              style={{
                marginRight: "auto",
                marginLeft: "auto",
                display: "block",
              }}
            >
              <ApplicationCharts
                applist={applicationchart.applicationList}
                appcount={applicationchart.applicationCountList}
              />
            </Grid>
          </Grid> */}
        </Container>
      </Box>
    </React.Fragment>
  );
};

export default Dashboard;
